<template>
  <AuthTemplate type="login">
    <p v-if="addText">{{ addText }}</p>
    <h1 v-else>Вход</h1>
    <form @submit.prevent="">
      <div class="mb-20">
        <custom-input
          placeholder="Номер телефона"
          v-model="form.phone"
          input_type="phone"
        />
        <error-text :text="errors.phone"/>
      </div>
      <div class="mb-20">
        <custom-input placeholder="Пароль" type="password" v-model="form.password"/>
        <error-text :text="errors.password"/>
      </div>
      <button-component mb="10px" variant="filled" type="submit" @click="login('login')">Войти</button-component>
    </form>
    <div class="restoreLink">
      <button @click="openModal('recovery')">Восстановить пароль</button>
    </div>
  </AuthTemplate>
</template>

<script>
import ButtonComponent from '../../../components/ui/buttons/button-component'
import CustomInput from '../../../components/ui/inputs/custom-input'
import AuthTemplate from '../../../templates/AuthTemplate'
import {mapMutations} from 'vuex'
import ErrorText from "@/components/ui/text/error-text";

export default {
  name: 'auth',
  props: {
    addText: String
  },
  mixins: [],
  data: () => ({
    form: {},
    errors: {}
  }),
  methods: {
    ...mapMutations(['openModal', 'signIn', 'closeModals']),
    login() {
      const prevPhone = this.form.phone
      try{
        const phone = parseInt(this.form.phone.replace(/\D+/g,""))
        this.form.phone = `+${phone}`
      } catch (e){
        return this.$set(this.errors, 'phone', ['Заполните это поле'])
      }

      this.$api.auth.login(this.form).then(({data}) => {
        this.signIn(data);
        this.closeModals();
        this.$toast.success('Успешная авторизация!');
      }).catch(({response}) => {
        this.form.phone = prevPhone
        this.errors = response.data.errors;
        this.$toast.error('Проверьте указанные данные!');
      })
    },
  },
  components: {ErrorText, ButtonComponent, CustomInput, AuthTemplate},
}
</script>

<style scoped lang="scss">
.restoreLink {
  margin-bottom: 30px;
  text-align: center;

  button {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #808080;
    text-decoration: none;
    border: none;
    background-color: transparent;
  }
}

p {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #383838;
  text-align: center;
  margin-bottom: 35px;
}

.mb-20 {
  margin-bottom: 20px;
}
</style>
